import React from 'react'
import { ViewType } from '../../../interfaces/internal/ViewProps';
import styles from './bladeopener.module.css'

interface Props{
    text: string;
    vtype: ViewType;
    isSelected:boolean;
    onClicked: (inp:ViewType) => void;
}
const BladeOpenerListItem = ({text,vtype,isSelected,onClicked}:Props) => {
  return (
    <li onClick={() => onClicked(vtype)} className={"list-group-item " + styles.list_item + " " + (isSelected ? styles.list_active : "")}>{text}</li>
  )
}

export default BladeOpenerListItem